import React, { MouseEvent } from "react";
import { useTranslation } from "i18n";
import { useMutation } from "react-query";
import { doesUserHaveEntitlements } from "shared-auth";
import { AddOnEntitlements } from "shared-types";
import { getFilmmakersSSOLink } from "shared-utils";
import { FMLogoDark } from "assets";
import LeftHandNavItem from "../../LeftHandNavItem";
import {
  NotificationToast,
  NotificationToastTypes,
} from "../../../../../Atoms/NotificationToast/NotificationToast";

const FilmmakersLeftHandNavItem = () => {
  const { t } = useTranslation();

  const hasFilmmakerEntitlements = doesUserHaveEntitlements(
    AddOnEntitlements.FilmmakersSync
  );

  const { mutate, isError, reset } = useMutation({
    mutationFn: async () => {
      const data = await getFilmmakersSSOLink(
        "https://www.filmmakers.eu/casting_calls"
      );

      window.open(data.url, "_blank");
    },
  });

  if (hasFilmmakerEntitlements)
    return (
      <LeftHandNavItem onClick={() => mutate()} isSubNav>
        {t("common:nav.links.filmmakers.viewJobs")}
        <FMLogoDark height={23} width={100} />
        <NotificationToast
          stickToComponent
          handleHide={(e?: MouseEvent<HTMLButtonElement>) => {
            e?.stopPropagation();
            reset();
          }}
          show={isError}
          type={NotificationToastTypes.Error}
          text={t("common:errorPopup.httpStatus.generic.body")}
          className="w-auto"
        />
      </LeftHandNavItem>
    );

  return null;
};

export default FilmmakersLeftHandNavItem;
